import React from "react";
import HeroSection from "../components/HeroSection";
import SkillsSection from "../components/SkillsSection";
import ExperienceSection from "../components/ExperienceSection";
import ProjectsSection from "../components/ProjectsSection";
import ResumeSection from "../components/ResumeSection";
import ContactSection from "../components/ContactSection";

const Home: React.FC = () => {
  // Data from resume
  const summary =
    "Software Developer with expertise in Python, Java, and C++. Passionate about building innovative solutions and solving complex problems.";

  const skills = [
    {
      category: "Machine Learning & Data Science:",
      items: [
        "Python",
        "NumPy",
        "Pandas",
        "Matplotlib",
        "Scikit-learn",
        "TensorFlow",
        "PyTorch",
        "Hugging Face Transformers",
        "ONNX",
        "YOLOv8",
        "SQL",
      ],
    },
    {
      category: "Programming Languages & Systems",
      items: [
        "C++",
        "Rust",
        "Java",
        "JavaScript",
        "Go",
        "Kotlin",
        "MATLAB",
        "ROS2",
        "PowerShell",
        "VBA",
        "ROS2",
        "Apriltags",
        "ConnectWise",
        "Kaseya",
      ],
    },
    {
      category: "Developer Tools",
      items: [
        "AWS",
        "Azure",
        "Docker",
        "GitHub Actions",
        "Git",
        "Linux",
        "Neovim",
        "FastAPI",
        "Redis",
        "MongoDB",
        "Visual Studio",
        "VS Code",
        "PyCharm",
        "SQL Server Management Studio",
      ],
    },
  ];

  const experiences = [
    {
      title: "Junior AWS Engineer",
      company: "Lincoln Financial Group",
      location: "Radnor, PA",
      period: "Aug 2025 - Current",
      responsibilities: [
      ],
    },
    {
      title: "Integration Services Engineer Intern (Returning)",
      company: "IT Solutions Consulting, Inc.",
      location: "Fort Washington, PA",
      period: "Dec 2022 – Jan 2023",
      responsibilities: [
        "Rejoined IT Solutions to support advanced DataVault (DV) configurations and network infrastructure optimization for client environments.",
        "Expanded SOPs and enhanced endpoint monitoring in ConnectWise and Kaseya, reducing incident response times.",
      ],
    },
    {
      title: "Integration Services Engineer Intern",
      company: "IT Solutions Consulting, Inc.",
      location: "Fort Washington, PA",
      period: "Jun 2022 – Aug 2022",
      responsibilities: [
        "Architected and deployed 3 enterprise-grade DataVault clusters (500 TB+ total) to deliver secure, high-performance storage, improving data ingestion throughput by 40%",
        "Authored and standardized 5+ SOPs for firewall upgrades, Layer 2/3 switch configurations, and DV assembly, boosting team compliance and consistency by 30%",
        "Optimized network switch configurations across 15 client sites, reducing downtime by 10% and increasing average packet throughput by 12%",
        "Leveraged ConnectWise & Kaseya to automate endpoint management, remote monitoring, and service ticket triage, cutting incident response times by 35% and achieving a 95% first-contact resolution rate",
      ],
    },
    {
      title: "Contracted Software Engineer",
      company: "Chestnut Hill College",
      location: "Philadelphia, PA",
      period: "Jul 2022 – Oct 2022",
      responsibilities: [
        "Led data audit and standardization of the Psychology Department’s student records (names, DOBs, emails, ID numbers), auditing 500+ files and correcting 96% of discrepancies, reducing manual cleanup time by 30%",
        "Performed monthly audits on 1,500 student and financial records, resolving 90% of anomalies to enhance overall data accuracy",
        "Developed modular ETL scripts in Python, VBA, and PowerShell to reconcile 50K rows/month, improving load throughput by 35%",
      ],
    },
  ];

  const projects = [
    {
      title: "TurtleBot Swarm Intelligence",
      description:
        "Contributed to a real-time swarm system using TurtleBots and Raspberry Pi for military-style search and rescue operations.",
      technologies: [
        "Python",
        "ROS 2 Jazzy",
        "LiDAR",
        "Vex Ultrasonic",
        "YOLOv8",
        "Redis",
        "MongoDB",
        "Gazebo",
      ],
      githubUrl: "https://github.com/dmrph/TurtleBot-Swarm-AI",
      image: "/images/turtlebot.png",
    },
    {
      title: "Global Internet Usage 3D Demo",
      description:
        "An interactive 3D globe visualization to explore global internet usage statistics by country and continent. Built with Three.js and GSAP, featuring real-time data from the World Bank.",
      technologies: ["Three.js", "GSAP", "World Bank API", "HTML", "CSS"],
      githubUrl: "https://github.com/dmrph/global-internet-usage-viz",
      liveUrl: "https://vizinternetusage.com",
      image: "/images/globe.png",
    },
    {
      title: "DecibelDetect",
      description:
        "Designed a web platform that visualizes urban noise pollution using user-submitted decibel data with interactive noise heatmap and real-time data visualization.",
      technologies: ["React", "Google Maps API", "FastAPI", "Python"],
      githubUrl: "https://github.com/dmrph/DecibelDetect",
      image: "/images/decibel.jpg",
    },
    {
      title: "T5Summarize",
      description:
        "Fine-tuned and deployed a T5 model for summarizing news and long-form text, with a Streamlit demo allowing users to input text and receive AI-generated summaries.",
      technologies: ["Python", "Hugging Face", "PyTorch", "Streamlit", "NLP"],
      githubUrl: "https://github.com/dmrph/T5Summarize",
      image: "/images/t5summarize.png",
    },
    {
      title: "File-Processing-System",
      description:
        "CMPSC 472 - Operating Systems - File Processing System. Program is meant to count frequency of a given word.",
      technologies: ["C"],
      githubUrl: "https://github.com/dmrph/File-Processing-System",
      image: "/images/file-processing.jpg",
    },
    {
      title: "RoutePlanner",
      description:
        "Route planner for data structures class at Penn State University. Spring of 2024.",
      technologies: ["HTML"],
      githubUrl: "https://github.com/dmrph/RoutePlanner-CMPSC-Final",
      image: "/images/route-planner.png",
    },
  ];

  // Resume URLs
  const resumeUrl = "/David_Murphy_Resume.pdf"; // Will be copied to public folder
  const downloadUrl = "/David_Murphy_Resume.pdf";

  return (
    <div>
      <HeroSection
        name="David Murphy"
        title="Software Developer"
        summary={summary}
      />
      <SkillsSection skills={skills} />
      <ExperienceSection experiences={experiences} />
      <ProjectsSection projects={projects} />
      <ResumeSection resumeUrl={resumeUrl} downloadUrl={downloadUrl} />
      <ContactSection />
    </div>
  );
};

export default Home;
